export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.2-1414.49",
  commitId: "9af5266f11a339c467c17343af900cfa946731b1",
  commitTime: "2026-09-02T14:14:49.000Z",
});
